module.exports = __webpack_public_path__ + "static/media/2.41ae8bf2.jpg";